
import "../css/style.scss";
import Search from "./modules/search";
import Rate from "./modules/rate";
import ListSelect from "./modules/listselect";
const search = new Search();
const rate = new Rate();
const listSelect = new ListSelect();

